<app-compliance-nav [activeMenuItem]="'tplComplianceReport'"></app-compliance-nav>


<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <button mat-raised-button color="primary" style="margin-right: 10px;" [disabled]="isLoading" (click)="gotoPrevMonth()">Previous</button>
    <button mat-raised-button color="primary" [disabled]="isLoading" (click)="gotoNextMonth()">Next</button>

  </div>

</div>

<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50" style="padding: 15px;">

<mat-card>

  <mat-progress-bar *ngIf="isLoadingMonth" mode="indeterminate"></mat-progress-bar>

  <div>
    <h3>Monthly Report</h3>
  </div>
  <div>
    <div>Month: {{ monthYear }}</div>
    <ng-container *ngIf="monthlyReport">

      <table border="1" cellpadding="5" cellspacing="0">
        <thead>
        <tr>
          <th>Measurement</th>
          <th style="text-align: right;">Value</th>

        </tr>
        </thead>
        <tbody>
        <tr>
          <td>New Customers</td>
          <td style="text-align: right;">{{ monthlyReport.newCustomersCount }}</td>

        </tr>
        <tr>
          <td>Relationships Closed</td>
          <td style="text-align: right;">{{ monthlyReport.relationshipsClosedCount }}</td>

        </tr>
        <tr>
          <td>Active Customers</td>
          <td style="text-align: right;">{{ monthlyReport.activeCustomers }}</td>

        </tr>
        <tr>
          <td>Dormant Customers</td>
          <td style="text-align: right;">{{ monthlyReport.dormantCustomers }}</td>

        </tr>
        <tr>
          <td>Inactive Customers</td>
          <td style="text-align: right;">{{ monthlyReport.inactiveCustomers }}</td>

        </tr>
        <tr>
          <td>Total Customers marked vulnerable by end</td>
          <td style="text-align: right;">{{ monthlyReport.vulnerableCustomers }}</td>

        </tr>
        <tr>
          <td>CC Report</td>
          <td style="text-align: right;">{{ monthlyReport.ccReportName }}</td>

        </tr>
        </tbody>
      </table>
      <div>
        <table border="1" cellpadding="5" cellspacing="0">
          <thead>
          <tr>
            <th>Country Code</th>
            <th>Country Name</th>
            <th>Customer Count</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let country of monthlyReport.individualCustomersByCountry">
            <td>{{ country.countryIsoCode }}</td>
            <td>{{ country.countryName }}</td>
            <td class="text-right">{{ country.count }}</td>
          </tr>
          </tbody>
        </table>
      </div>

    </ng-container>


    <div style="background-color: yellow; padding: 4px; border-radius: 4px; color: red; margin-top: 10px;">
      <div>Note! These values will change if you navigate to this page at a later date, since cards and orders may have been closed, re-opened, expired or cancelled.</div>
    </div>
    <div style="background-color: yellow; padding: 4px; border-radius: 4px; color: red; margin-top: 10px;">
      <div>These values are most accurate on the first of the (next) month and the accuracy also depends on how close the latest CC report of the respective month is to the last day of the month</div>
    </div>
  </div>


</mat-card>

  </div>
  <div fxFlex="50" style="padding: 15px;">

<mat-card>

  <mat-progress-bar *ngIf="isLoadingQuarter" mode="indeterminate"></mat-progress-bar>

  <div>
    <h3>Quarterly Report</h3>
  </div>
  <div>

    <div>Quarter: {{ quarterYear }}</div>
    <ng-container *ngIf="quarterlyReport">
      <table border="1" cellpadding="5" cellspacing="0">
        <thead>
        <tr>
          <th>Measurement</th>
          <th style="text-align: right;">Value</th>

        </tr>
        </thead>
        <tbody>
        <tr>
          <td>New Customers</td>
          <td style="text-align: right;">{{ quarterlyReport.newCustomersCount }}</td>

        </tr>

        <tr>
          <td>New Customers MALTA</td>
          <td style="text-align: right;">{{ quarterlyReport.newCustomersCountMalta }}</td>

        </tr>

        <tr>
          <td>New Customers EEA excl. Malta</td>
          <td style="text-align: right;">{{ quarterlyReport.newCustomersCountEeaExclMalta }}</td>

        </tr>

        <tr>
          <td>Relationships Closed</td>
          <td style="text-align: right;">{{ quarterlyReport.relationshipsClosedCount }}</td>

        </tr>

        <tr>
          <td>Relationships Closed Malta</td>
          <td style="text-align: right;">{{ quarterlyReport.relationshipsClosedCountMalta }}</td>

        </tr>

        <tr>
          <td>Relationships Closed EEA excl. Malta</td>
          <td style="text-align: right;">{{ quarterlyReport.relationshipsClosedCountEeaExclMalta }}</td>

        </tr>

        <tr>
          <td>Active Customers</td>
          <td style="text-align: right;">{{ quarterlyReport.activeCustomers }}</td>

        </tr>
        <tr>
          <td>Dormant Customers</td>
          <td style="text-align: right;">{{ quarterlyReport.dormantCustomers }}</td>

        </tr>
        <tr>
          <td>Inactive Customers</td>
          <td style="text-align: right;">{{ quarterlyReport.inactiveCustomers }}</td>

        </tr>
        <tr>
          <td>Total Customers marked vulnerable by end</td>
          <td style="text-align: right;">{{ quarterlyReport.vulnerableCustomers }}</td>

        </tr>


        <tr>
          <td>EDD applied</td>
          <td style="text-align: right;">{{ quarterlyReport.eddAppliedCount }}</td>

        </tr>

        <tr>
          <td>EDD applied Malta</td>
          <td style="text-align: right;">{{ quarterlyReport.eddAppliedCountMalta }}</td>

        </tr>

        <tr>
          <td>EDD applied EEA excl. Malta</td>
          <td style="text-align: right;">{{ quarterlyReport.eddAppliedCountEeaExclMalta }}</td>

        </tr>

        <tr>
          <td>CC Report</td>
          <td style="text-align: right;">{{ quarterlyReport.ccReportName }}</td>

        </tr>
        </tbody>
      </table>


      <div>
        <h3>All customers</h3>
        <table border="1" cellpadding="5" cellspacing="0">
          <thead>
          <tr>
            <th>Country Code</th>
            <th>Country Name</th>
            <th>Customer Count</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let country of quarterlyReport.allCustomersByCountry">
            <td>{{ country.countryIsoCode }}</td>
            <td>{{ country.countryName }}</td>
            <td class="text-right">{{ country.count }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div>
        <h3>Active customers</h3>
        <table border="1" cellpadding="5" cellspacing="0">
          <thead>
          <tr>
            <th>Country Code</th>
            <th>Country Name</th>
            <th>Customer Count</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let country of quarterlyReport.activeCustomersByCountry">
            <td>{{ country.countryIsoCode }}</td>
            <td>{{ country.countryName }}</td>
            <td class="text-right">{{ country.count }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div>
        <h3>Inactive customers</h3>
        <table border="1" cellpadding="5" cellspacing="0">
          <thead>
          <tr>
            <th>Country Code</th>
            <th>Country Name</th>
            <th>Customer Count</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let country of quarterlyReport.inactiveCustomersByCountry">
            <td>{{ country.countryIsoCode }}</td>
            <td>{{ country.countryName }}</td>
            <td class="text-right">{{ country.count }}</td>
          </tr>
          </tbody>
        </table>
      </div>


    </ng-container>

    <div style="background-color: yellow; padding: 4px; border-radius: 4px; color: red; margin-top: 10px;">
      <div>Note! These values will change if you navigate to this page at a later date, since cards and orders may have been closed, re-opened, expired or cancelled.</div>
    </div>
    <div style="background-color: yellow; padding: 4px; border-radius: 4px; color: red; margin-top: 10px;">
      <div>These values are most accurate on the first of the (next) quarter and the accuracy also depends on how close the latest CC report of the respective quarter is to the last day of the quarter</div>
    </div>

  </div>

</mat-card>

  </div>
</div>
